
import { defineComponent, reactive, ref, UnwrapRef, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import Axios from '../../../axios-vendor'
import axios from 'axios'
import Swal from 'sweetalert2'

interface FormState {
  email: string;
  password: string;
  remember: boolean;
}

export default defineComponent({
  components: {
    
  },
  setup () {
    const router = useRouter()
    const api = process.env.VUE_APP_BASEURL
    const login_url = process.env.VUE_APP_LOGIN_PERSONNEL_URL
    const loading = ref(false)

    const userState: UnwrapRef<FormState> = reactive({
      email: '',
      password: '',
      remember: false,
    })

    const forgotPassword = () => {
      router.push('/forgot-password')
    }

    const handleFinish = async (values: FormState) => {
      await axios.post(`${api}login-vendor`, userState).then((res) => {
        if(res.data.data.code == 403) {
          Swal.fire({
            icon: 'error',
            title: res.data.data.message,
          })
          return false;
        }
        window.localStorage.setItem('PAYMENT_PORTAL_VENDOR_TOKEN', res.data.data.token)
        window.localStorage.setItem('PAYMENT_PORTAL_VENDOR_ID', res.data.data.user.id)
        Axios.defaults.headers.common['Authorization'] = `Bearer ${window.localStorage.getItem('PAYMENT_PORTAL_VENDOR_TOKEN')}`
        Axios.defaults.headers['Authorization'] = `Bearer ${window.localStorage.getItem('PAYMENT_PORTAL_VENDOR_TOKEN')}`
        if(res.data.data.user.first_time_logged_in === true) {
          router.push('/change-password')
        } else {
          router.push('/dashboard')
        }
      }).catch((err) => {
        Swal.fire({
          icon: 'error',
          title: 'Incorrect email or password',
        })
      })
    }

    onMounted(() => {
      if(window.localStorage.getItem("PAYMENT_PORTAL_VENDOR_TOKEN")) {
        router.push('/dashboard')
      }
    });
    
    // const handleFinish = () => {
    //   router.push('/dashboard')
    // }
    const googleRedirect = () => {
      // window.location.href = `${api}talent-profile/redirect`
    }

    return {
      loading,
      userState,
      login_url,
      handleFinish,
      forgotPassword,
      googleRedirect
    }
  },
})
